<template>
  <el-table :height="height" border :data="sortedData">
    <el-table-column sortable prop="label">
      <template slot-scope="scope">
        <span class="title">{{ scope.row.label }}</span>
      </template>
    </el-table-column>
    <el-table-column
      align="right"
      sortable
      style="text-align: right"
      width="80px"
      prop="percentage"
    >
      <template slot-scope="scope">
        <span class="percentage">{{ scope.row.percentage.toFixed(2) }}%</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { orderBy } from 'lodash';

export default {
  name: 'ProfileTableChart',
  computed: {
    sortedData() {
      return orderBy(this.data, ['percentage'], ['desc']);
    },
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 270,
    },
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 0.8em;
  font-weight: bold;
  white-space: nowrap;
}
.percentage {
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// ProfileTableChart.vue?d50b552a